import React from 'react'

import { Form, Radio } from 'antd'
import get from 'lodash/get'
import identity from 'lodash/identity'
import PT from 'prop-types'

import { getHelp, getValidateStatus } from '../../../utils/forms'

const FormRadioGroupInput = props => {
  const { input, label, meta, options, displayMappingFn, normalizeDataFn, additionalStyles } = props
  const { onChange, value } = input

  const antdOptions = displayMappingFn(options)

  const onChangeFn = event => {
    const selectedValue = get(event, 'target.value', null)

    if (selectedValue === 'No Access') onChange()
    else {
      const normalizedValue = normalizeDataFn([selectedValue])
      onChange(normalizedValue)
    }
  }

  const antdValues = displayMappingFn(value ? [value] : []).join('')

  const labelId = `field-label-${input.name.replace(/[^a-zA-Z0-9]/g, '-')}`

  return (
    <div role="group" aria-labelledby={labelId} style={{ marginBottom: 10, marginLeft: 10 }}>
      <span id={labelId} aria-hidden="true" style={{ fontWeight: 'bold', marginBottom: 5 }}>
        {label}
      </span>
      <Form.Item
        hasFeedback
        help={getHelp(meta)}
        validateStatus={getValidateStatus(meta)}
        style={{
          ...{
            marginBottom: 0,
          },
          ...additionalStyles,
        }}
      />
      <div style={{ fontWeight: 'normal', marginLeft: 15 }}>
        <Radio.Group
          onChange={onChangeFn}
          value={antdValues && antdValues !== '' ? antdValues : 'No Access'}
        >
          {[...antdOptions, 'No Access'].map(opt => (
            <Radio key={opt} value={opt} aria-label={opt}>
              <span aria-hidden="true">{opt}</span>
            </Radio>
          ))}
        </Radio.Group>
      </div>
    </div>
  )
}

FormRadioGroupInput.propTypes = {
  displayMappingFn: PT.func,
  normalizeDataFn: PT.func,
}

FormRadioGroupInput.defaultProps = {
  displayMappingFn: identity,
  normalizeDataFn: identity,
}

export default FormRadioGroupInput
